import { getFirestore } from "utilities/firebase";
import { collection, doc } from "firebase/firestore";

export const pathToSegments = (path: string) => path.split("/").filter(Boolean);

export const isDocument = (path: string) =>
  pathToSegments(path).length % 2 === 0;

export const createRef = (path: string) => {
  const db = getFirestore();
  const segments = pathToSegments(path);

  if (isDocument(path)) {
    return doc(db, segments[0], ...segments.slice(1));
  }

  return collection(db, segments[0], ...segments.slice(1));
};
